export const searchToFormDevice = (d, alertId) => {
  const formDevice = {
    ...d,
    label: d.title,
    value: d.id,
    alertLabel: 'Switch on/off'
  };

  if (alertId) {
    return {
      ...formDevice,
      alertOn: !!alertId,
      showAlertIcon: !!alertId
    };
  }

  return formDevice;
};

export const getExcludeIds = data => {
  const uniqueIds = [...new Set(data.map(item => item.id))];

  return uniqueIds.join(',');
};
